// import { FlatList } from "dripsy";
import { styled } from "dripsy";
import { FlashList } from "@shopify/flash-list";

const FlatList = styled(FlashList)();
export default FlatList;
